export const dummyCommunitiesData = {
  communities: [
    {
      id: "11112221",
      name: "קהילה לדוגמה - מורים למתמטיקה",
      image_url: "/images/dummy-community-images/teacher-students-image.png",
      managers: [
        {
          id: "10066",
          name: "שרה לוי",
        },
      ],
      member_count: 124,
      location: "ישראל, תל אביב",
      tags: [
        {
          name: "מורים",
        },
        {
          name: "מתמטיקה",
        },
        {
          name: "סטודנטים",
        },
        {
          name: "ספרים",
        },
        {
          name: "למידה",
        },
      ],
    },
    {
      id: "11112222",
      name: "קהילה לדוגמה - מאלפי כלבים גוש דן",
      image_url: "/images/dummy-community-images/dogs-image.png",
      managers: [
        {
          id: "10066",
          name: "אושרי כהן",
        },
      ],
      member_count: 4763,
      location: "ישראל, באר שבע",
      tags: [
        {
          name: "כלבים",
        },
        {
          name: "בעלי חיים",
        },
        {
          name: "אוהבי בע\"ח",
        },
        {
          name: "טבעונות",
        },
        {
          name: "דוגי-סיטרים",
        },
      ],
    },
    {
      id: "abc1003",
      name: "קהילה לדוגמה - אמהות הרצליניות",
      image_url: "/images/dummy-community-images/family-image.png",
      managers: [
        {
          id: "10066",
          name: "אורנה יענקלביץ'",
        },
      ],
      member_count: 22543,
      location: "נתניה, ישראל",
      tags: [
        {
          name: "אמהות",
        },
        {
          name: "ילדים",
        },
        {
          name: "חברים",
        },
        {
          name: "תינוקות",
        }
      ],
    },
    {
      id: "abc1004",
      name: "קהילה לדוגמה - מגדל אלון 1",
      image_url: "/images/dummy-community-images/buildings-image.png",
      managers: [
        {
          id: "10066",
          name: "חיים כהן",
        },
      ],
      member_count: 1005,
      location: "רוטשילד 17, תל אביב, ישראל",
      tags: [
        {
          name: "בניין אלון 1",
        },
        {
          name: "בית",
        },
        {
          name: "בית דירות",
        },
      ],
    },
    {
      id: "abc1005",
      name: "קהילה לדוגמה - קיבוץ אור הנר",
      image_url: "/images/dummy-community-images/countryside-image.png",
      managers: [
        {
          id: "10066",
          name: "עמי דרומי",
        },
      ],
      member_count: 35,
      location: "רוטשילד 17, תל אביב, ישראל",
      tags: [
        {
          name: "כפר",
        },
        {
          name: "אוהבי טבע",
        },
        {
          name: "Country Life",
        },
        {
          name: "חיי כפר",
        },
      ],
    },
    {
      id: "abc1006",
      name: "קהילה לדוגמה - סטודנטים אונ' בן גוריון",
      image_url: "/images/dummy-community-images/students-image.png",
      managers: [
        {
          id: "10066",
          name: "חיים דנילוביץ'",
        },
      ],
      member_count: 598,
      location: "רוטשילד 17, תל אביב, ישראל",
      tags: [
        {
          name: "עסקים",
        },
        {
          name: "סטודנטים",
        },
        {
          name: "אוניברסיטה",
        },
        {
          name: "לימודים",
        },
      ],
    },
  ],
  max_page_number: 1,
};

export const dummyZonesData = [
  {
    id: 1,
    name: "North District",
  },
  {
    id: 2,
    name: "Haifa District",
  },
  {
    id: 3,
    name: "Jerusalem District",
  },
  {
    id: 4,
    name: "Tel Aviv District",
  },
  {
    id: 5,
    name: "South District",
  },
  {
    id: 6,
    name: "Center District",
  },
];

export const dummyMemberRanges = [
  "1-100",
  "101-500",
  "501-2,000",
  "2,001-10,000",
  "10,001+",
];
